export default __webpack_public_path__ + "static/media/avocado_pasta.a8beed76.jpg";